import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatterActions, MatterDispatch } from '@state/matter';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { MatterFields } from '@models/matter';
import { Address } from '@models/address';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './address.hooks';
import { AI_GENERATED_ICON } from '@core/util/icon';
import { DisplayState } from '@components/address/address.component';
import { NOTE_TYPES } from '../../../../ui/note/note.component';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';

@Component({
	selector: 'app-matter-address',
	templateUrl: './address.component.html',
	standalone: false,
})
export class MatterAddressComponent implements OnInit {
	testHooks = TestHooks;
	public AI_ICON = AI_GENERATED_ICON.icon;
	public AI_TOOLTIP = AI_GENERATED_ICON.tooltip;
	public AI_CLASSES = AI_GENERATED_ICON.classes;
	private field = MatterFields.ADDRESS;

	@Input() label = 'Property Address';
	@Input() skeletonLoading = false;
	@Output() onFocus = new EventEmitter<string>();

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	public address$ = this.store.select(SelectedMatter.address);

	public fieldMappings$ = this.store.select(SelectedMatter.getFieldMappings);

	public cardState$ = this.address$.pipe(
		map((address) => (address?.street ? DisplayState.CARD : DisplayState.EDIT)),
	);

	public showLabelToolTip$: Observable<string>;
	public showWarningNote$: Observable<boolean>;

	@Dispatch()
	getAction = (
		_matterId: string,
		_address: Address,
	): MatterActions.SetAddress =>
		new MatterActions.SetAddress({ matterId: _matterId, address: _address });

	constructor(
		private matterDispatch: MatterDispatch,
		private store: Store,
	) {}

	ngOnInit(): void {
		this.showLabelToolTip$ = combineLatest([
			this.fieldMappings$,
			this.address$,
		]).pipe(
			map(([fieldMappings, address]) =>
				address?.street && !!fieldMappings?.propertyDetails?.address
					? this.AI_TOOLTIP
					: '',
			),
		);

		this.showWarningNote$ = combineLatest([
			this.fieldMappings$,
			this.address$,
		]).pipe(
			map(
				([fieldMappings, address]) =>
					!address?.street && !!fieldMappings?.propertyDetails?.address,
			),
		);
	}

	addressChanged(ev): void {
		this.matterDispatch.SetAddress(this.matterId, ev);
	}

	_onFocus(): void {
		this.onFocus.emit(this.field);
	}

	protected readonly NOTE_TYPES = NOTE_TYPES;
}
